import { createSlice } from "@reduxjs/toolkit";
import {
  cancelAccountDeletion,
  fetchAccountDeletionStatus,
  scheduleAccountDeletion,
} from "./slice-extensions/account-deletion-slice-extension";

interface AccountDeletionState {
  /** UTC moment the deletion executes; null = nothing scheduled. */
  scheduledFor: string | null;
  status: "idle" | "loading" | "succeeded" | "failed";
}

const initialState: AccountDeletionState = {
  scheduledFor: null,
  status: "idle",
};

const accountDeletionSlice = createSlice({
  name: "accountDeletion",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccountDeletionStatus.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAccountDeletionStatus.fulfilled, (state, action) => {
        state.scheduledFor = action.payload.scheduledFor;
        state.status = "succeeded";
      })
      .addCase(fetchAccountDeletionStatus.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(scheduleAccountDeletion.fulfilled, (state, action) => {
        state.scheduledFor = action.payload.scheduledFor;
      })
      .addCase(cancelAccountDeletion.fulfilled, (state, action) => {
        state.scheduledFor = action.payload.scheduledFor;
      });
  },
});

export const selectAccountDeletionScheduledFor = (state: {
  accountDeletion: AccountDeletionState;
}) => state.accountDeletion.scheduledFor;

export const selectAccountDeletionStatus = (state: { accountDeletion: AccountDeletionState }) =>
  state.accountDeletion.status;

export default accountDeletionSlice.reducer;
